import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface IBlockConfirmDialogProps {
  // LOCAL_TYPE_JUSTIFIED: component props interface tightly coupled to this dialog
  open: boolean;
  onOpenChange: (open: boolean) => void;
  targetName: string;
  targetType: 'user' | 'organisation';
  isBlocked: boolean;
  onConfirm: () => void;
  isLoading: boolean;
}

export function BlockConfirmDialog({
  open,
  onOpenChange,
  targetName,
  targetType,
  isBlocked,
  onConfirm,
  isLoading,
}: IBlockConfirmDialogProps) {
  const action = isBlocked ? 'Unblock' : 'Block';
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {action} {targetType}
          </DialogTitle>
          <DialogDescription>
            {isBlocked
              ? `Are you sure you want to unblock ${targetName}? They will regain access to the platform.`
              : `Are you sure you want to block ${targetName}? They will be unable to log in.`}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            variant={isBlocked ? 'default' : 'destructive'}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? 'Processing...' : action}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
